export const GET_PAYMENT_START = 'GET_PAYMENT_START'; 
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS'; 
export const GET_PAYMENT_FAILURE = 'GET_PAYMENT_FAILURE'; 
